import Plugin from 'src/plugin-system/plugin.class';
import anime from 'animejs/lib/anime.es.js';

export default class PreloaderPlugin extends Plugin {

    init() {

        // Wrap every letter in a span
        var textWrapper = document.querySelector('.ml6 .letters');
        textWrapper.innerHTML = textWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

        var logEl = document.querySelector('.battery-log');

        var targets = {
            year: new Date().getFullYear()
        };

        anime.timeline({ loop: false })
            .add({
                targets: '.preloader__container',
                opacity: 1,
                easing: "easeInOutQuad",
                duration: 1000,
                begin: function() {
                    var video = $('.hero-widget__video-wrapper video:visible');

                    if (video.length) {
                        video.get(0).pause();
                        video.get(0).currentTime = 0;
                    }
                }
            })
            .add({
                targets: targets,
                year: 1700,
                round: 1,
                delay: 500,
                easing: 'easeInOutQuad',
                duration: 2000,
                update: function() {
                    textWrapper.innerHTML = targets.year;
                }
            })
            .add({
                targets: '.preloader__container',
                opacity: 0,
                easing: "easeInOutQuad",
                duration: 1000,
                delay: 500
            })
            .add({
                targets: '.preloader',
                opacity: 0,
                easing: "easeInOutQuad",
                duration: 1500,
                complete: function() {
                    document.querySelector('.preloader').style.visibility = 'hidden';

                    var video = $('.hero-widget__video-wrapper video:visible');
                    if (video.length) {
                        video.get(0).play();
                    }
                }
            });

    }

}